/**
 * Christmas Theme Configuration
 * Automatically activates every December
 */

export const isChristmasSeason = (): boolean => {
  const now = new Date();
  const year = now.getFullYear();
  const startDate = new Date(`${year}-12-01T00:00:00`);
  const endDate = new Date(`${year}-12-25T23:59:59`); // Ends with Winter Madness sale
  return now >= startDate && now <= endDate;
};

export const christmasColors = {
  red: "0 80% 50%",
  green: "142 76% 36%",
  gold: "45 93% 47%",
  snow: "0 0% 95%",
  holly: "142 70% 30%",
  cranberry: "348 83% 47%",
};

export const christmasEmojis = {
  tree: "🎄",
  santa: "🎅",
  gift: "🎁",
  snowflake: "❄️",
  star: "⭐",
  bell: "🔔",
  candy: "🍬",
  gingerbread: "🍪",
  reindeer: "🦌",
  snowman: "⛄",
};

export const christmasGradients = {
  festive: "linear-gradient(135deg, hsl(0 80% 50% / 0.15), hsl(142 76% 36% / 0.15))",
  snow: "linear-gradient(180deg, hsl(210 50% 98% / 0.1), transparent)",
  gold: "linear-gradient(135deg, hsl(45 93% 47% / 0.2), hsl(38 92% 50% / 0.1))",
};

// Christmas recipe themes for Chaos Kitchen
export const christmasRecipeThemes = [
  { value: "christmas-cookies", label: "Christmas Cookies", emoji: "🍪" },
  { value: "gingerbread", label: "Gingerbread Creations", emoji: "🦌" },
  { value: "christmas-dinner", label: "Christmas Dinner", emoji: "🎄" },
  { value: "holiday-desserts", label: "Holiday Desserts", emoji: "🥧" },
  { value: "warm-drinks", label: "Warm Holiday Drinks", emoji: "🍵" },
  { value: "festive-appetizers", label: "Festive Appetizers", emoji: "⭐" },
  { value: "christmas-candy", label: "Christmas Candy", emoji: "🍬" },
  { value: "holiday-sides", label: "Holiday Side Dishes", emoji: "🥗" },
  { value: "christmas-breakfast", label: "Christmas Breakfast", emoji: "🥞" },
  { value: "winter-soups", label: "Winter Soups", emoji: "🍲" },
];

// Logo paths for seasonal switching
export const logos = {
  regular: '/chaos-kitchen-logo.webp',
  christmas: '/chaos-kitchen-christmas-logo.webp',
};

export const getSeasonalLogo = (): string => {
  return isChristmasSeason() ? logos.christmas : logos.regular;
};
